import type { PontoDoAnalitoResponse } from '@/api/generated/model';

/**
 * O ponto que veio de um laudo de OUTRO laboratório.
 *
 * ⚠️ Ele entra na mesma série das medições da casa — é o que se quer: ver a
 * evolução inteira do paciente. Mas não é a mesma medição: outro laboratório,
 * possivelmente outro método, e o número foi transcrito de um documento. Todo
 * lugar que desenha ou lista o ponto precisa dizer isso, e é para dizer do
 * MESMO jeito nos três (linha, barras, tabela) que o texto mora aqui.
 */
export function ehExterno(
  ponto: Pick<PontoDoAnalitoResponse, 'origem'> | null | undefined,
): boolean {
  return ponto?.origem === 'EXTERNO';
}

/** "Laudo externo · Lab de Fora", ou `null` quando o ponto é da casa. */
export function rotuloDeExterno(
  ponto: Pick<PontoDoAnalitoResponse, 'origem' | 'laboratorio'> | null | undefined,
): string | null {
  if (!ehExterno(ponto)) return null;
  return ponto?.laboratorio ? `Laudo externo · ${ponto.laboratorio}` : 'Laudo externo';
}

/** A frase da legenda — igual nos dois gráficos. */
export const LEGENDA_DE_EXTERNO =
  'Laudo externo: valor transcrito do documento de outro laboratório. O método e a unidade podem não ser os da casa.';
